exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (min-width: 768px) {\r\n    #title { font-size: 5em}\r\n    #subtitle { font-size: 3em}\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/claudio/Projects/thebatclaudio.github.io/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/home/claudio/Projects/thebatclaudio.github.io/node_modules/postcss-loader?{"ident":"postcss"}!/home/claudio/Projects/thebatclaudio.github.io/src/app/home/css/768.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/app/home/css/768.css
// module chunks = main